import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-168bf10a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tool-description"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
export default {
  __name: 'ToolDescription',
  props: {
    title: {
      type: String,
      default: '工具使用说明'
    },
    description: {
      type: String,
      default: ''
    },
    features: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", null, _toDisplayString(__props.title), 1), __props.description ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.description), 1)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "description"), __props.features && __props.features.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.features, (feature, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("strong", null, _toDisplayString(feature.title), 1), _createTextVNode("：" + _toDisplayString(feature.description), 1)]);
      }), 128))])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")]);
    };
  }
};